import {
  SET_PRODUCT,
  SET_PRODUCTS,
  SET_CATEGORIES,
  SET_OPTIONS,
  SET_RECURRING_PROFILE,
} from '../actions/types'

const initialState = {
  product: {},
  products: [],
  categories: [],
  recurringProfile: [],
  options: [],
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_PRODUCT:
      return {
        ...state,
        product: action.product,
      }
    case SET_PRODUCTS:
      return {
        ...state,
        products: action.products,
      }
    case SET_CATEGORIES:
      return {
        ...state,
        categories: action.categories,
      }
    case SET_OPTIONS:
      return {
        ...state,
        options: action.options,
      }
    case SET_RECURRING_PROFILE:
      return {
        ...state,
        recurringProfile: action.recurringProfile,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/ducks/reducers/product.js